import { render, staticRenderFns } from "./details.vue?vue&type=template&id=4d2c4f76&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=4d2c4f76&prod&lang=less&scoped=true"
import style1 from "./details.vue?vue&type=style&index=1&id=4d2c4f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c4f76",
  null
  
)

export default component.exports